{
  "id": "campaign-128",
  "name": "Victory Bowl",
  "seed": "campaign:128",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r.....QQQQ.....r",
    "...:........:...",
    ".a.:a......a:.a.",
    "...::::::::::...",
    ".a..a......a..a.",
    "........~....~.~",
    ".......~~~......",
    "..#.....~..#....",
    "::::::::::::::::",
    "~~....a..a......",
    "~~.a........a...",
    "~.a..........a.#",
    "...::::::::::...",
    "..x:........:...",
    "...:........:...",
    "......QQQQ.....S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 10,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 13,
      "y": 8
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 3
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 7,
      "y": 13
    },
    {
      "kind": "gas",
      "x": 15,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 14
    },
    {
      "kind": "rare",
      "x": 1,
      "y": 9
    }
  ],
  "balls": {
    "first": 18,
    "every": 14
  },
  "generatorVersion": 3,
  "level": 128,
  "biome": "stadium",
  "par": {
    "reel": 8385,
    "push": 7150,
    "selfPropelled": 6564,
    "tractor": 5460,
    "zeroTurn": 4652,
    "fairway": 2662
  },
  "goldTime": {
    "reel": 8175,
    "push": 6929,
    "selfPropelled": 6396,
    "tractor": 5330,
    "zeroTurn": 4533,
    "fairway": 2475
  },
  "routeTries": {
    "par": {
      "reel": 14,
      "push": 6,
      "selfPropelled": 0,
      "tractor": 24,
      "zeroTurn": 0,
      "fairway": 13
    },
    "gold": {
      "reel": 36,
      "push": 25,
      "selfPropelled": 25,
      "tractor": 25,
      "zeroTurn": 25,
      "fairway": 40
    }
  }
}
